// UserModal.js
import React from 'react';
import './AuditsModal.css';

const AuditsModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="audits-modal">
      <div className="audits-modal-content">
        <h2 className='audits-title'>Audits Modal</h2>
        {/* Add your modal content here */}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default AuditsModal;
